import React from "react"
import { withRouter } from "react-router-dom";
import { authOperations } from './state'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { Button, FormGroup, FormControl, FormLabel, Container, Card, InputGroup } from 'react-bootstrap';
import { FaKey, FaCheck, FaLock } from 'react-icons/fa'
import '../../../includes/custom/css/resetpassword.css';
import { SUCCESS, NEWPASSWORD_LENGTH, CONFIRMPASSWORD_LENGTH, EMPTY_STRING, RESET_PASSWORD, NEW_PASSWORD, REQUESTCOUNT, CONFIRM_PASSWORD } from '../../../utils/constants';
import { MSG_EMPTY_REQUIRED, PASSWORD_INVALID_LENGTH, PASSWORD_MISMATCH, REDIRECT, SHSAA_WEBSITE, INVALID_REQUEST } from '../../../utils/messages';
import MemberHeader from "../../components/MemberHeader";

class ResetPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            newPassword: '',
            userId: '',
            token: '',
            errors: '',
            isValid: true,
            confirmPassword: ''
        }
    }

    componentDidMount() {


        let userId = this.props.match.params.userId;
        let token = this.props.match.params.token;

        this.setState({ userId, token })

        let resetPasswordModel = {
            "userId": userId,
            "token": token,
            "newPassword": ""
        }

        this.props.checkRequestCount(resetPasswordModel)
            .then((result) => {
                if (REQUESTCOUNT >= result.data) {
                    this.setState({ isValid: false })
                }
            })

    }

    validateForm() {
        return NEWPASSWORD_LENGTH < this.state.newPassword.length && CONFIRMPASSWORD_LENGTH < this.state.confirmPassword.length;
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();

        this.setState({errors: null})

        if (EMPTY_STRING === this.state.newPassword || EMPTY_STRING === this.state.confirmPassword) {
            this.setState({ errors: [MSG_EMPTY_REQUIRED] })
        }
        else if (6 > this.state.newPassword.trim().length || 6 > this.state.confirmPassword.trim().length) {
            this.setState({ errors: [PASSWORD_INVALID_LENGTH] })
        }

        else if (this.state.newPassword.trim() !== this.state.confirmPassword.trim()) {
            this.setState({ errors: [PASSWORD_MISMATCH] })
        }

        else {
            let resetPasswordModel = {
                "userId": this.state.userId,
                "token": this.state.token,
                "newPassword": this.state.newPassword
            }

            this.props.resetPassword(resetPasswordModel)
                .then((result) => {
                    if (SUCCESS === result.status) {
                        alert(REDIRECT)
                        window.location.assign(SHSAA_WEBSITE);
                    }
                })
        }

    }


    render() {
        return (
            <div>
                <MemberHeader isAuthenticated={this.props.isAuthenticated} />
                <Container className="reset-container">
                    <Card className="reset-card">
                        {this.state.isValid ?
                            (<div>
                                <div className="lock-div">
                                    <FaLock className="lock" />
                                </div>
                                <center><h2>{RESET_PASSWORD}</h2></center>
                                <center><h5 className="reset-errors">{this.state.errors}</h5></center>
                                <form onSubmit={this.handleSubmit}>
                                    <FormGroup controlId="newPassword">
                                        <FormLabel>{NEW_PASSWORD}</FormLabel>
                                        <InputGroup>
                                            <InputGroup.Prepend>
                                                <InputGroup.Text><FaKey /></InputGroup.Text>
                                            </InputGroup.Prepend>
                                            <FormControl
                                                size="lg"
                                                value={this.state.newPassword}
                                                onChange={this.handleChange}
                                                type="password"
                                                name="newPassword"
                                            />
                                        </InputGroup>
                                        <FormLabel>{CONFIRM_PASSWORD}</FormLabel>
                                        <InputGroup>
                                            <InputGroup.Prepend>
                                                <InputGroup.Text><FaCheck /></InputGroup.Text>
                                            </InputGroup.Prepend>
                                            <FormControl
                                                size="lg"
                                                value={this.state.confirmPassword}
                                                onChange={this.handleChange}
                                                type="password"
                                                name="confirmPassword"
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                    <Button
                                        block
                                        size="lg"
                                        disabled={!this.validateForm()}
                                        onClick={this.handleSubmit}
                                        type="submit"
                                        className="reset-btn"
                                    >
                                        {RESET_PASSWORD}
                                    </Button>
                                </form>
                            </div>)
                            :
                            (
                                <h3 className="invalid-request">{INVALID_REQUEST}</h3>
                            )
                        }
                    </Card>
                </Container>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.isAuthenticated
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        resetPassword: authOperations.resetPassword,
        checkRequestCount: authOperations.checkRequestCount
    },
    dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetPassword));